// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class NotificationRecord extends VerofreshRecord {
  static get TYPE_EMAIL () { return 'email' }
  static get TYPE_SMS () { return 'sms' }
  static get TYPE_IOS () { return 'ios' }
  static get TYPE_ANDROID () { return 'android' }
}

export default NotificationRecord
